import { Role, RoleType } from 'module/api/role/types';
import { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { RolesApi } from 'api/role';

export const ROLES_QUERY_KEY = ['roles'];

export const useGetAllRolesQuery = (
  queryOptions?: Omit<
    UseQueryOptions<Role[], Error, Role[], typeof ROLES_QUERY_KEY>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: ROLES_QUERY_KEY,
    queryFn: () => RolesApi.getAllRoles(),
    ...queryOptions,
  });
};
export const useVendorRolesQuery = (
  queryOptions?: Omit<
    UseQueryOptions<Role[], Error, Role[], typeof ROLES_QUERY_KEY>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<Role[]> =>
  useGetAllRolesQuery({
    ...queryOptions,
    select: (data) => data.filter(({ type }) => type === RoleType.Vendor),
  });
export const useCustomerRolesQuery = (
  queryOptions?: Omit<
    UseQueryOptions<Role[], Error, Role[], typeof ROLES_QUERY_KEY>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<Role[]> =>
  useGetAllRolesQuery({
    ...queryOptions,
    select: (data) => data.filter(({ type }) => type === RoleType.Customer),
  });
